<template>
  <v-card elevation="1">
    <v-card-text class="help-index">
      <div class="help-index__intro">
        <h2 class="mb-2">Інструкції користувача</h2>
        <p>
          Оберіть версію звітності та спосіб заповнення пакетів, щоб
          переглянути відповідну інструкцію.
        </p>
      </div>

      <v-row>
        <v-col v-for="guide in guides" :key="guide.routeName" cols="12" md="6">
          <v-card
            class="help-card h-100"
            elevation="0"
            role="link"
            tabindex="0"
            @click="openGuide(guide.routeName)"
            @keydown.enter="openGuide(guide.routeName)">
            <v-card-text class="d-flex align-start ga-4 pa-5">
              <v-avatar color="primary" variant="tonal" rounded="lg" size="48">
                <v-icon>{{ guide.icon }}</v-icon>
              </v-avatar>
              <div>
                <h3 class="mb-2">{{ guide.title }}</h3>
                <p class="text-medium-emphasis">{{ guide.description }}</p>
                <span class="help-card__link">
                  Відкрити інструкцію
                  <v-icon size="small">mdi-arrow-right</v-icon>
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HelpIndex',
  data() {
    return {
      guides: [
        {
          routeName: 'help-v1-web',
          title: 'V1 · Вебінтерфейс',
          description: 'Створення пакетів, заповнення форм і перевірка звітності.',
          icon: 'mdi-monitor-dashboard',
        },
        {
          routeName: 'help-v1-excel',
          title: 'V1 · Excel',
          description: 'Заповнення Excel-шаблону V1, імпорт та перевірка пакетів.',
          icon: 'mdi-microsoft-excel',
        },
        {
          routeName: 'help-v2-web',
          title: 'V2 · Вебінтерфейс',
          description:
            'Формування пакетів за оновленими вимогами НБУ, робота із забезпеченням та зв\'язками.',
          icon: 'mdi-monitor-dashboard',
        },
        {
          routeName: 'help-v2-excel',
          title: 'V2 · Excel',
          description:
            'Робота з Excel-шаблоном V2, аркушами «Звіт» і «Забезпечення», імпорт та валідація.',
          icon: 'mdi-microsoft-excel',
        },
      ],
    }
  },
  methods: {
    openGuide(routeName: string) {
      this.$router.push({ name: routeName })
    },
  },
})
</script>

<style scoped lang="scss">
.help-index {
  max-width: 1240px;
  margin: 0 auto;

  &__intro {
    max-width: 680px;
    margin-bottom: 32px;
  }
}

.help-card {
  cursor: pointer;
  border: 1px solid var(--light-grey);
  border-radius: 12px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease,
    transform 0.2s ease;

  &:hover,
  &:focus-visible {
    border-color: rgb(var(--v-theme-primary));
    box-shadow: 0 8px 24px rgba(var(--v-theme-primary), 0.12);
    transform: translateY(-2px);
    outline: none;
  }

  &__link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 16px;
    color: rgb(var(--v-theme-primary));
    font-weight: 600;
  }
}
</style>
